import { render, staticRenderFns } from "./UserFiles.vue?vue&type=template&id=e81a14f0&"
import script from "./UserFiles.vue?vue&type=script&lang=js&"
export * from "./UserFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports